import { NgModule } from '@angular/core';
import { ParkingVariableComponent } from './parking-variable.component';
import { ParkingFormModule } from '../parking-form/parking-form.module';
import { COMMON_MODULES } from '../../constants/common-modules';

@NgModule({
  declarations: [ParkingVariableComponent],
  imports: [...COMMON_MODULES, ParkingFormModule],
  exports: [ParkingVariableComponent],
})
export class ParkingVariableModule {}
